module.exports = __webpack_public_path__ + "media/images/og-fbae77d102b22919388d05c3cfaf075b.png";